import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

import employmentTypes from 'data/employment_types';

export default function EmploymentType({ member }) {
  return (

    <ValueItem
      icon="employment-type-icon"
      label="Employment Type"
    >
      {employmentTypes.find((gender) => gender.value === member.employment_type)?.label}
    </ValueItem>
  );
}

EmploymentType.propTypes = {
  member: PropTypes.object.isRequired,
};
